<template>
  <div class="home">
    <quote class="quote-top"
      >Voller Spannung erwartet, auf vielfachen Wunsch und doch aus eigenem
      Willen - <span class="font-weight-bold">wir heiraten!</span></quote
    >
    <div class="home-news-container">
      <entry title="Willkommen" date="2021-11-07T20:00">
        Liebe Familie,<br />
        Liebe Freunde,<br />
        gerne erinnern wir uns an die wundervolle Hochzeitsfeier mit euch
        zurück. Wir möchten uns für die vielen Bilder und Videos bedanken, die
        ihr uns geschickt habt. Wir haben sie für euch in einer
        <a href="/gallery">Galerie</a> aufbereitet.
        <br />
        <br />
        Herzliche Grüße<br />
        Meloni
      </entry>

      <entry title="Der Countdown läuft ..." date="2021-07-12T20:20">
        Liebe Familie,<br />
        Liebe Freunde,<br />
        für den 31.07.2021 benötigen wir von euch einen Genesenen- oder
        Geimpftennachweis oder ein Test der nicht älter als 24h zum Beginn der
        Feier ist.<br />
        Bitte bringt den Nachweis zur Kirche mit und zeigt ihn vor oder nach dem
        Gottesdienst unserem Beauftragten, Benjamin Zanoll, vor. Der Nachweis
        ist später für die Location wichtig. Eine Testmöglichkeit vor Ort gibt
        es nicht.<br />
        <br />
        Am Morgen nach der Hochzeit wird es, für alle die wollen, ein
        gemeinsames Frühstück im Lamm geben. Wer keine Übernachtung im Lamm
        gebucht hat, hat die Möglichkeit sich bei uns für ein Frühstück im Lamm
        anzumelden. Frühstück gibt es von 08:00 - 10:00 Uhr.<br />
        Bei Interesse schreibt uns bitte bis zum 15.07.21 eine Mail, dann melden
        wir euch an.<br />
        <br />
        Herzliche Grüße<br />
        Meloni
      </entry>

      <entry title="Nur mit euch!" date="2021-05-23T19:23">
        <div class="floating-image">
          <v-img src="images/2020-05-28-We-Do.jpg" />
        </div>
        Eine Hochzeit zu zweit ist nicht so unser Ding!<br />
        Daher verschieben wir unser Fest auf folgendes Datum
        <div class="news-highlight">
          31. Juli 2021
        </div>
        <br />
        Wie bisher geplant findet unsere Trauung um 14:00 Uhr in der Kirche
        "Heilige Drei Könige" in Merklingen statt. Wir möchten die Vorfreude nun
        endlich zur Freude machen und mit euch nach der Trauung im Gasthof Lamm
        in Asch feiern.<br />
        <br />
        Wir freuen uns schon riesig darauf mit euch anzustoßen!<br />
        <br />
        Herzliche Grüße<br />
        Meloni
      </entry>

      <entry title="Same Love, new Plans" date="2021-03-24T20:16">
        <div class="floating-image">
          <v-img src="images/2019-12-20-Standesamtliche-Hochzeit-2.jpg" />
        </div>
        Liebe Gäste,<br />
        <br />
        wir wagen einen neuen Versuch und möchten die Hochzeit, eventuell mit
        gewissen Hygienemaßnahmen, feiern.<br />

        Kurzfristig kann es immer noch zu Änderungen kommen.<br />

        Unsere Trauung findet

        <div class="news-highlight">
          am 19. Juni 2021 um 14:00 Uhr
        </div>
        in der Kirche "Heilige Drei Könige" in Merklingen statt. Anschließend
        möchten wir es mit euch im Gasthof Lamm in Asch so richtig krachen
        lassen.<br />

        Herzliche Grüße<br />
        Meloni
      </entry>

      <entry title="Lasst uns gemeinsam später feiern" date="2020-05-14T17:16">
        <div class="floating-image">
          <v-img src="images/2020-04-Sellenberg.jpg" />
        </div>
        Liebe Familie, liebe Freunde,<br />
        <br />
        Flitterwochen ohne euch, absolut! Hochzeit feiern ohne euch, undenkbar!
        Schweren Herzens müssen wir aufgrund der aktuellen Situation unser
        Hochzeitsdatum leider verschieben.<br />

        <div class="news-highlight">
          Wir werden am 19. Juni 2021 heiraten!
        </div>
        Wir lassen uns unsere Laune und Freude nicht verderben und wollen
        keinesfalls auf eure Anwesenheit verzichten. Bitte haltet euch den neuen
        Termin frei. Über alle weiteren Details werden wir euch über die
        Homepage informieren.

        <div class="news-highlight">
          Love will never be cancelled!
        </div>

        Herzliche Grüße und bleibt gesund,<br />
        Meloni
      </entry>

      <entry title="Change the date?!" date="2020-04-25T20:28">
        Liebe Familie, liebe Freunde,<br />
        <br />
        leider ist es derzeit nicht mehr so sicher, ob wir unsere Hochzeitsfeier
        wie geplant durchführen können.<br />
        Wir haben einen Alternativtermin für unsere Hochzeit am
        <b>19.06.2021</b> reserviert!<br />
        Bisher planen wir aber, dass unsere Feier am 20.06.2020 stattfindet.<br />
        Ende Mai können wir euch sicher sagen, ob unsere Hochzeit verschoben
        werden muss.
        <div class="news-highlight">
          A little (postponed) party never killed nobody!
        </div>
        Herzliche Grüße und bleibt gesund,<br />
        Meloni
      </entry>
    </div>
    <quote class="quote-bottom">
      Voller Spannung erwartet, auf vielfachen Wunsch und doch aus eigenem
      Willen - <span class="font-weight-bold">wir heiraten!</span>
    </quote>
  </div>
</template>
<style scoped>
.home {
  width: 100%;
  height: 100%;
  text-align: center;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media only screen and (max-width: 800px) {
  .home {
    padding-top: 100px;
  }

  .quote-top {
    display: none;
  }

  .quote-bottom {
    margin-top: 50px;
  }
}

@media only screen and (min-width: 801px) {
  .quote-bottom {
    display: none;
  }
}

@media only screen and (min-width: 451px) {
  .floating-image {
    float: right;
    min-width: 20%;
    max-width: 200px;
    margin-left: 5px;
  }
}

@media only screen and (max-width: 450px) {
  .floating-image {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-content: center;
    width: 100%;
    padding-bottom: 8px;
  }

  .floating-image div {
    align-self: center;
    max-width: 250px;
  }
}

.home-news-container {
  padding: 20px;
}

.news-highlight {
  padding: 10px;
  text-align: center;
  color: hsla(193, 100%, 55%, 0.7);
  font-weight: bold;
}
</style>

<script>
import Quote from "../app/Quote";
import moment from "moment";
import Entry from "./Entry";

export default {
  name: "home",
  components: {
    Entry,
    Quote
  },
  data: () => ({
    newsDateFormatted2: moment("2020-05-14T17:16").format("LLLL"),
    newsDateFormatted: moment("2020-04-25T20:28").format("LLLL")
  })
};
</script>
